import { Typography } from '@mui/material'
import React from 'react'

const Info = () => {
  return (
    <Typography>
      We understand that your business is unique to you and your clientele. In
      this section, you will be able to customize the information you would like
      to track and how you'd like to track it. These fields will automatically
      drop into the CRM for you. Let's get started building your world.
    </Typography>
  )
}

export default Info
